<template>
  <div
    class="app-loading-screen"
    role="status"
    aria-live="polite"
    :aria-label="displayQuote"
    data-testid="app-loading-screen"
  >
    <div class="app-loading-screen__mark-wrap" data-testid="app-loading-screen__mark">
      <div class="app-loading-screen__mark">
        <div class="app-loading-screen__frame">
        <img
          class="app-loading-screen__asset"
          src="/img/auth/loading/mark-c.svg"
          alt=""
          data-testid="app-loading-screen__frame"
        />
        </div>
        <div class="app-loading-screen__trails">
          <div class="app-loading-screen__trail app-loading-screen__trail--4">
            <LoadingTrail :variant="4" />
          </div>
          <div class="app-loading-screen__trail app-loading-screen__trail--3">
            <LoadingTrail :variant="3" />
          </div>
          <div class="app-loading-screen__trail app-loading-screen__trail--2">
            <LoadingTrail :variant="2" />
          </div>
          <div class="app-loading-screen__trail app-loading-screen__trail--1">
            <LoadingTrail :variant="1" />
          </div>
        </div>
        <div class="app-loading-screen__orbiter">
          <img
            class="app-loading-screen__glow app-loading-screen__asset"
            src="/img/auth/loading/dot-glow.svg"
            alt=""
            width="101"
            height="101"
            data-testid="app-loading-screen__glow"
          />
          <img
            class="app-loading-screen__dot app-loading-screen__asset"
            src="/img/auth/loading/mark-dot.svg"
            alt=""
            width="19.4976"
            height="19.3434"
            data-testid="app-loading-screen__dot"
          />
        </div>
        <div class="app-loading-screen__letter">
          <div class="app-loading-screen__letter-flip">
            <img
              class="app-loading-screen__asset"
              src="/img/auth/loading/mark-stroke.svg"
              alt=""
              width="92.5987"
              height="95.7499"
              data-testid="app-loading-screen__letter"
            />
          </div>
        </div>
      </div>
    </div>
    <p
      v-if="displayQuote"
      class="app-loading-screen__quote"
      :key="displayQuote"
      data-testid="app-loading-screen__quote"
    >
      {{ displayQuote }}
    </p>
  </div>
</template>

<script>
import {
  LOGIN_SCREENS_QUOTE_INTERVAL_MS,
  fetchLoginBrandSlides,
} from '../Auth/components/AuthBrandPanelUtils';
import LoadingTrail from './LoadingTrail.vue';

export default {
  name: 'AppLoadingScreen',
  components: {
    LoadingTrail,
  },
  props: {
    quote: { type: String, default: '' },
  },
  data() {
    return {
      quotes: [],
      quoteIndex: 0,
    };
  },
  computed: {
    displayQuote() {
      if (this.quote) return this.quote;
      return this.quotes[this.quoteIndex] || '';
    },
  },
  created() {
    this.loadQuotes();
  },
  beforeDestroy() {
    this.clearQuoteTimer();
  },
  methods: {
    clearQuoteTimer() {
      if (this._quoteTimer) {
        clearInterval(this._quoteTimer);
        this._quoteTimer = null;
      }
    },
    startQuoteRotation() {
      this.clearQuoteTimer();
      if (this.quotes.length < 2) return;
      this._quoteTimer = setInterval(() => {
        this.quoteIndex = this.pickRandomQuoteIndex(this.quoteIndex);
      }, LOGIN_SCREENS_QUOTE_INTERVAL_MS);
    },
    pickRandomQuoteIndex(except) {
      const count = this.quotes.length;
      if (count <= 1) return 0;
      let next = Math.floor(Math.random() * count);
      if (next === except) next = (next + 1) % count;
      return next;
    },
    async loadQuotes() {
      if (this.quote || !this.axios) return;
      const payload = await fetchLoginBrandSlides(this.axios);
      if (this._isDestroyed) return;
      this.quotes = payload.quotes || [];
      this.quoteIndex = this.pickRandomQuoteIndex(-1);
      this.startQuoteRotation();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AppLoadingScreen.scss';
</style>
